import { ReactElement } from 'react';
import { Divider, Tabs } from 'antd';
import { ContentBlock } from '../../../components/layout/ContentBlock';
import type { Honbu } from '../types';
import { BRANCHES_BY_HONBU } from '../constants';
import Title from './Title';
import BranchSection from './BranchSection';
import BranchTabLabel from './BranchTabLabel';
import GStaffUpload from './GStaffUpload';
import { CommonSettingGroup, ContentCard } from './styles';

interface Props {
  honbu: Honbu;
}

const Content = ({ honbu }: Props): ReactElement => {
  const branches = BRANCHES_BY_HONBU[honbu];
  const items = branches.map(branch => ({
    key: branch.code,
    label: <BranchTabLabel branch={branch} />,
    children: <BranchSection branch={branch} />,
  }));

  return (
    <ContentBlock>
      <ContentCard>
        <Title honbu={honbu} />
        <Tabs items={items} />
        {honbu === '2honbu' && (
          <CommonSettingGroup>
            <Divider orientation='start' orientationMargin={0}>
              拠点共通の設定
            </Divider>
            <GStaffUpload />
          </CommonSettingGroup>
        )}
      </ContentCard>
    </ContentBlock>
  );
};

export default Content;
